import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { useToasts } from "@air/provider-toast";
import { useCallback } from "react";
import { getFavoritedMessage } from "~/constants/messages";
import { useFollowBoard } from "~/swr-hooks/followedBoards/useFollowBoard";
import { useFavoriteBoards } from "./useFavoriteBoards";
import { useUnfavoriteBoards } from "./useUnfavoriteBoards";
/**
 * This hook gives you a function to pass clips to that will toggle their current FavoritedBoard
 * state. If any of them are currently unfavorited, it will favorite all of them. If all
 * of them are currently FavoritedBoard, it will unfavorite all of them.
 */ export const useToggleFavoritedBoard = ()=>{
    const { showToast } = useToasts();
    const { favoriteBoards } = useFavoriteBoards();
    const { unfavoriteBoards } = useUnfavoriteBoards();
    const { followBoard: { isPending, mutate } } = useFollowBoard();
    const toggleFavoritedBoard = useCallback(async (param)=>{
        let { board, trackLocation } = param;
        const successful = !board.hasCurrentUser ? await favoriteBoards({
            boards: [
                board
            ],
            trackLocation
        }) : await unfavoriteBoards({
            boards: [
                board
            ],
            trackLocation
        });
        if (successful) {
            showToast(getFavoritedMessage(!board.hasCurrentUser, undefined, board.title), {
                timeBeforeAutoDismiss: 2000,
                suffix: !board.hasCurrentUser && /*#__PURE__*/ _jsx(Button, {
                    appearance: "ghost",
                    color: "grey",
                    isLoading: isPending,
                    onClick: ()=>{
                        mutate({
                            boardId: board.id,
                            includeDescendants: false
                        }, {
                            onSuccess: ()=>{
                                showToast("You will receive notifications about changes in ".concat(board.title));
                            }
                        });
                    },
                    children: "Follow"
                })
            });
        }
    }, [
        favoriteBoards,
        isPending,
        mutate,
        showToast,
        unfavoriteBoards
    ]);
    return {
        toggleFavoritedBoard
    };
};
